// extracted by mini-css-extract-plugin
export default {"icon":"gmdaD","icon--red":"eiUXb","icon--themeColor":"Tc3j5","icon--themeDarkColor":"isakX","iconsContainer":"HHoI0"};